module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-bg-376c132dfc505771ec97275e4996b3c1.png";